import { useFormState } from "react-hook-form"
import ExpanderPanel from "@rio-cloud/rio-uikit/ExpanderPanel"
import { FormattedMessage } from "react-intl"
import { TransportationReport } from "@/model/transportation-report/transportation-report"
import { FreightForwarderDetails } from "./FreightForwarderDetails"
import { LoadingDetails } from "./LoadingDetails"
import { UnloadingDetails } from "./UnloadingDetails"
import { MeansOfTransport } from "./MeansOfTransport"
import { FuelType } from "./FuelType"

export type TransportDetailsFormInput = Pick<TransportationReport, "transportDetails">

export const TransportDetailsPanel = () => {
    const formState = useFormState<TransportDetailsFormInput>({
        name: "transportDetails",
    })

    const hasErrors = formState.errors.transportDetails !== undefined

    return <ExpanderPanel
        open
        title={<>
            {hasErrors ? <span className={"rioglyph rioglyph-error-sign padding-right-5"}/> : undefined}
            <FormattedMessage id={"freightPaymentDetails.transportData"}/>
        </>
        }
        iconLeft={true}
        bsStyle={"separator"}
        titleClassName={hasErrors ? "text-danger" : ""}
        unmountOnExit={false}
    >
        <FreightForwarderDetails/>
        <LoadingDetails/>
        <UnloadingDetails/>
        <MeansOfTransport/>
        <FuelType />
    </ExpanderPanel>
}
